import axios from "axios";
import { useFormik } from "formik";
import React, { useRef, useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import ErrorText from "../common/ErrorText";
import styles from "../../Styles/modal.module.css";
import apiCall from "../../helpers/apifactory";

const PickupRequest = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        .scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classNameList.add('fixed-header-desktop') : document.querySelector("nav").classNameList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classNameList.add('fixed-header-desktop') : document.querySelector("a").classNameList.remove('fixed-header-desktop')
    },
    false
  );

  const modalRef = useRef(null);

  const [token, settoken] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    console.log("------>");
    apiCall.middlewareAuthToken().then((token) => {
      const {
        data: { result: accessToken },
      } = token;
      settoken(accessToken.accessToken);
    });
  }, []);

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      mobNum: "",
      pickCity: "",
      pickAddress: "",
      dropAddress: "",
      dropCity: "",
      service: "",
      otherDetails: "",
      recaptcha: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("This is Required"),
      lastName: Yup.string().required("This is Required"),
      mobNum: Yup.string()

        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      pickCity: Yup.string().required("This is Required"),
      pickAddress: Yup.string().required("This is Required"),
      dropAddress: Yup.string().required("This is Required"),
      dropCity: Yup.string().required("This is Required"),
      service: Yup.string().required("This is Required"),
      otherDetails: Yup.string(),
      recaptcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      const body = {
        // toEmailID: "customerservices@tcs.com.pk",
        toEmailID: "allpackngousers@tcs.com.pk",
        fromEmailID: "customerservices@tcs.com.pk",
        emailSubject: "PacknGo",
        emailText: `
            firstName: ${values?.firstName} <br/>
            lastName: ${values?.lastName} <br/>
            mobNum: ${values?.mobNum} <br/>
            pickCity: ${values?.pickCity} <br/>
            pickAddress: ${values?.pickAddress} <br/>
            dropAddress: ${values?.dropAddress} <br/>
            dropCity: ${values?.dropCity} <br/>
            service: ${values?.service} <br/>
            otherDetails: ${values?.otherDetails} <br/>
          `,
        cc: "allpackngousers@tcs.com.pk",
        bcc: "allpackngousers@tcs.com.pk",
        attachments: [],
        replyTo: "allpackngousers@tcs.com.pk",
      };
      // const header = {
      //   Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIk5vdGlmaWNhdGlvbiIsIkludGVybmF0aW9uYWxCb29raW5nIiwiVHJhY2siLCJUVEMiLCJGU1AiLCJDbGFpbVNlcnZpY2UiLCJXTVMiLCJHU00iLCJSTVMiLCJXb3JrZmxvdyIsIkNMUyJdLCJjbGllbnRpZCI6IjIxMTExMTExMSIsImF1ZCI6WyJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iLCJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iXSwiaXNzIjoibWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiNjFmNzllZTgtMDZjNi00NmY0LWExM2MtNWUwOWZjODU4Mzg1IiwibmJmIjoxNjczMjc4MTU4LCJleHAiOjE3NTk2NzQ1NTgsImlhdCI6MTY3MzI3ODE1OH0.FVA0xgGz6BjVdbXglSR94to8oSTZEaMWxRVWTP8DC38'}`,
      // };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    },
  });
  useEffect(() => {
    const inputElement = document.getElementById("mobNum");

    const handleInputChange = (event) => {
      const inputValue = event.target.value;
      const maxLength = 11;

      if (inputValue.length > maxLength) {
        event.target.value = inputValue.slice(0, maxLength);
      }

      formik.handleChange(event);
    };

    inputElement.addEventListener("input", handleInputChange);

    return () => {
      inputElement.removeEventListener("input", handleInputChange);
    };
  }, [formik]);

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="text-[30px] sm:text-[40px] font-bold">PACKnGO </h1>
      </div>
      {/* <!-- Heading --> */}

      <div className="my-[3rem]">
        <div className="flex flex-col justify-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-[auto] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Quick Quote</h2>
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-1">
                <div className="flex  gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="firstName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="firstName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstName}
                      />
                      <label
                        for="firstName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        First Name
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.firstName && formik?.errors?.firstName
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="lastName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="lastName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                      />
                      <label
                        for="lastName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Last Name
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.lastName && formik?.errors?.lastName
                      }
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="mobNum"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="mobNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobNum}
                        // maxLength={11}
                      />
                      <label
                        for="mobNum"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.mobNum && formik?.errors?.mobNum}
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="pickCity"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickCity"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickCity}
                      />
                      <label
                        for="pickCity"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup City
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.pickCity && formik?.errors?.pickCity
                      }
                    />
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="pickAddress"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickAddress"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickAddress}
                      />
                      <label
                        for="pickAddress"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup Address*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.pickAddress &&
                        formik?.errors?.pickAddress
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="dropAddress"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="dropAddress"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.dropAddress}
                      />
                      <label
                        for="dropAddress"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Delivery Address*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.dropAddress &&
                        formik?.errors?.dropAddress
                      }
                    />
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="dropCity"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="dropCity"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.dropCity}
                      />
                      <label
                        for="dropCity"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Dropoff City
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.dropCity && formik?.errors?.dropCity
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="service"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="service"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.service}
                      />
                      <label
                        for="service"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Service*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.service && formik?.errors?.service}
                    />
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="otherDetails"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="otherDetails"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.otherDetails}
                      />
                      <label
                        for="otherDetails"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Other Details
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.otherDetails &&
                        formik?.errors?.otherDetails
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="flex flex-col justify-center mt-[1rem] ">
            <div className="flex gap-4 md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-[auto]">
              <div className="g-recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCH}
                  onChange={(value) => {
                    console.log("Captcha value:", value);
                    formik.setFieldValue("recaptcha", value);
                  }}
                />
              </div>
            </div>
          </div>
          {/*  */}
          <button
            type="submit"
            onClick={formik?.handleSubmit}
            className=" text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[auto] mt-[1rem] mx-[1rem] sm:mx-[auto] rounded-md mb-6 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Quick Quote
          </button>
        </div>
      </div>

      <div
        ref={modalRef}
        // style={backdropStyle}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default PickupRequest;
